export default "__VITE_ASSET___AEbLtLw__"